import { cx } from 'cvb';
import PropTypes from 'prop-types';
import icons from '../../../config/styles/icons';
import { SKUIdSeller } from '../../../containers/common/PDPBasicInfoShared';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withLabels } from '../../../utils/LabelsContext';
import { withProduct } from '../../../utils/ProductContext';
import MyLists from '../../MyLists/MyLists';
import { VariantId } from '../../PDP';
import ProductPrices from '../../ProductPrices/ProductPrices';
import ProductTopSpecifications from '../../ProductTopSpecifications/v2';
import Divider from '../../ui/Divider';
import Heading from '../../ui/Heading/Heading';
import LinkButton from '../../ui/LinkButton/LinkButton';
import { useProductSpecificationConnect } from '../hooks/useProductSpecificationConnect';
import { ProductSpecificationConnectStyles } from './style';

const ProductSpecificationConnect = ({ product, appCtx, labels }) => {
  const hookData = useProductSpecificationConnect({ product, appCtx });

  if (!hookData.shouldRender) {
    return null;
  }

  const {
    isMobile,
    isMobileOrTablet,
    displayPrice,
    isViewPlanActive,
    planUrl,
    productAttributes,
    productId,
    cmrPoints,
    regionCode,
    isSoCom,
    activeVariant: { id },
    variant: { variantId, offeringId, offerings },
  } = hookData;

  return (
    <div
      className="product-specification-connect"
      data-backend-category={productAttributes.merchantCategoryId}
      data-availability={productAttributes.isPrimeAvailable}
      data-published={productAttributes.isPublished}
      id="testId-ProductSpecificationConnect-container"
    >
      <div
        className={cx(
          'product-specification-connect__content',
          isMobile && 'product-specification-connect__content--mobile'
        )}
      >
        {isViewPlanActive ? (
          <div className="product-specification-connect__plan-active">
            {displayPrice && displayPrice.length > 0 && (
              <div className="product-specification-connect__prices">
                <div className="product-specification-connect__info-message">{labels.TEAM_FROM_LABEL}</div>
                <div className="product-specification-connect__prices-content">
                  <ProductPrices
                    prices={displayPrice}
                    productId={productId}
                    regionCode={regionCode}
                    cmrPoints={cmrPoints}
                    isMobile={isMobile}
                  />
                </div>
              </div>
            )}

            <div className="product-specification-connect__plan-review">
              <div className="product-specification-connect__info-message">{labels.IDEAL_PLAN_LABEL}</div>
              <p className="product-specification-connect__plan-text">{labels.PLAN_REVIEW_LABEL}</p>
            </div>

            <div
              className={cx(
                'product-specification-connect__button-container',
                isMobileOrTablet && 'product-specification-connect__button-container--mobile'
              )}
            >
              <LinkButton
                href={planUrl}
                type="rebranding"
                size={!isMobileOrTablet ? 'large' : 'medium'}
                id="testId-ProductSpecificationConnect-viewPlan"
                className="product-specification-connect__button"
              >
                <span className="product-specification-connect__button-text">
                  {labels.VIEW_PLANES_LABEL_REBRANDING}
                </span>
              </LinkButton>
              <MyLists appCtx={appCtx} product={{ productId, variantId, offeringId }} isPDPpage />
            </div>
          </div>
        ) : (
          <div className="product-specification-connect__no-plan">
            <div className="product-specification-connect__no-plan-header">
              <Heading labels={3} variation="title8">
                {labels.NO_PLAN_TITLE}
              </Heading>
            </div>
            <p className="product-specification-connect__no-plan-text">{labels.NO_PLAN_LABEL}</p>
          </div>
        )}

        <ProductTopSpecifications scollToElementId="productSpecificationsAccordion" />

        <div className="variant-id-seller">
          <span className="barcode-icon" dangerouslySetInnerHTML={{ __html: icons.barcode }} />
          <VariantId variantId={id} labels={labels} isSoCom={isSoCom} />
          {SKUIdSeller({
            appCtx,
            offerings,
            labels,
            regionCode,
            product,
          })}
        </div>

        <Divider variant="thin" />
      </div>

      <style jsx>{ProductSpecificationConnectStyles}</style>
    </div>
  );
};

ProductSpecificationConnect.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
};

export default withProduct(withApplicationContext(withLabels(ProductSpecificationConnect)));
